import { useEffect } from 'react';
import Image from 'next/image';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';

import { FagmoblerAlgoliaProductVariant } from '@fagmobler/types';

import { Radio } from '@fagmobler/ui';

export type VariantsProps = {
  variants: FagmoblerAlgoliaProductVariant[];
  current: FagmoblerAlgoliaProductVariant['objectID'];
  onChange: (variantId: string) => void;
};

export function Variants({ variants, current, onChange }: VariantsProps) {
  const { register, watch } = useForm({ defaultValues: { variant: current } });

  const selectedVariant = watch('variant');

  useEffect(() => {
    if (selectedVariant !== current) {
      onChange(selectedVariant);
    }
  }, [selectedVariant, current, onChange]);

  return (
    <section className={clsx('mb-8', 'print:hidden')}>
      <header>
        <h4 className={clsx('hd-base', 'my-4')}>Varianter av produktet</h4>
      </header>

      <ul className={clsx('border-1', 'border-neutral-40')}>
        {variants.map((variant, i) => (
          <li
            key={variant.objectID}
            className={clsx('py-2', 'px-2', {
              'bg-neutral-40': i % 2 === 1,
            })}
          >
            <label
              htmlFor={variant.objectID}
              className={clsx('flex', 'items-center')}
            >
              {variant.image && (
                <div className={clsx('mr-4')}>
                  <Image
                    src={variant.image}
                    alt={variant.posterName || variant.colour || 'Variant'}
                    height="32"
                    width="32"
                  />
                </div>
              )}

              {variant.colour}

              <span
                className={clsx('ml-auto', 'mr-4', {
                  'text-primary-50': variant.campaignPrice,
                })}
              >
                {variant.campaignPrice || variant.price}
              </span>

              <Radio
                id={variant.objectID}
                size="sm"
                value={variant.objectID}
                {...register('variant')}
              />
            </label>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Variants;
